
const carousel = () => {
	const runMarquee = (selector) => {
		const element = selector;
		const clone = element.innerHTML;
		const firstElement = element.children[0];

		let i = 0;

		element.insertAdjacentHTML('beforeend', clone);
		element.insertAdjacentHTML('beforeend', clone);
		element.insertAdjacentHTML('beforeend', clone);
		element.insertAdjacentHTML('beforeend', clone);
		element.insertAdjacentHTML('beforeend', clone);
		element.insertAdjacentHTML('beforeend', clone);
		element.insertAdjacentHTML('beforeend', clone);

		setInterval(() => {
			firstElement.style.marginLeft = `-${i}px`;

			if (i > firstElement.offsetWidth * 2) i = 0;

			i = i + parseFloat(0.5);
		}, 0);
	}

	const wrappers = document.querySelectorAll('.heading-carousel__wrapper');

	if (wrappers) {
		wrappers.forEach(wrapper => {
			runMarquee(wrapper)
		});
	}
}


document.addEventListener('DOMContentLoaded', () => {
	carousel()
});